export default {
  line1: 'Sistema eFactura by Unifiedpost',
  line2: `${new Date().getFullYear()} Unifiedpost Group`,
  jcyl: {
    line3: 'igacyl.factura@jcyl.es'
  }
}
